function make(tag, className = '', text = '') {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text) node.textContent = text;
  return node;
}

function descriptionFor(state) {
  if (state.updateAvailable) return 'A Bolt Forge update is ready to apply.';
  if (state.installed) return 'Installed. Launch Bolt Forge from your Home Screen or the browser Open in app control when available.';
  if (state.ios) return 'Safari on iPhone/iPad does not show the same Install/Open in app prompt. Tap HOW TO for Apple’s web-app install steps.';
  return 'Use the browser Install / Open in app control. This fallback stays small and optional.';
}

function actionFor(state) {
  if (state.updateAvailable) return 'UPDATE';
  if (state.installed) return 'INSTALLED';
  if (state.installPromptAvailable) return 'INSTALL';
  if (state.ios) return 'HOW TO';
  return 'BROWSER';
}

export function mountPwaSettingsRow(stage, pwaManager, { onIosHowTo } = {}) {
  const panel = stage?.querySelector?.('.bf-shell-panel');
  if (!panel || !pwaManager) return null;

  const state = pwaManager.state();
  const row = make('div', 'bf-setting-row bf-pwa-row');
  row.dataset.pwaSettings = 'native-first';

  const copy = make('div', 'bf-setting-row__copy');
  const title = make('strong', '', 'Bolt Forge App');
  const description = make('span', '', descriptionFor(state));
  copy.append(title, description);

  const action = make('button', 'bf-pwa-action', actionFor(state));
  action.type = 'button';
  action.disabled = state.installed && !state.updateAvailable;

  action.addEventListener('click', async () => {
    const current = pwaManager.state();
    if (current.updateAvailable) {
      description.textContent = 'Applying the latest Bolt Forge update…';
      action.textContent = 'UPDATING';
      action.disabled = true;
      await pwaManager.applyUpdate();
      return;
    }
    if (current.installed) return;
    if (current.ios) {
      onIosHowTo?.();
      description.textContent = 'Guided tutorial: Share → Add to Home Screen → Open as Web App → Add. Then launch Bolt Forge from the Home Screen icon.';
      action.textContent = 'HOW TO';
      return;
    }
    if (current.installPromptAvailable) {
      const result = await pwaManager.requestInstall();
      const next = pwaManager.state();
      if (next.installed || result?.outcome === 'accepted') {
        description.textContent = 'Install accepted. Bolt Forge can now launch like an app.';
        action.textContent = 'INSTALLED';
        action.disabled = true;
      } else {
        description.textContent = 'You can install anytime from the browser Install / Open in app control.';
        action.textContent = 'BROWSER';
      }
      return;
    }
    description.textContent = 'Use the Install icon in the address bar or browser menu. Once installed, the browser may show Open in app.';
    action.textContent = 'BROWSER';
  });

  const actions = panel.querySelector('.bf-shell-panel__actions');
  panel.insertBefore(row, actions || null);
  return row;
}
